import { render, staticRenderFns } from "./DeleteConnectionButton.vue?vue&type=template&id=5f9023de"
import script from "./DeleteConnectionButton.vue?vue&type=script&lang=js"
export * from "./DeleteConnectionButton.vue?vue&type=script&lang=js"
import style0 from "./DeleteConnectionButton.vue?vue&type=style&index=0&id=5f9023de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports